import React from "react";
import { Accordion, Flex } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import FAQ_DATA from "../../../faq-consts";

type FAQItem = {
    ANSWER: string;
    QUESTION: string;
};

interface FAQProps {
    items?: FAQItem[] | Record<string | number, FAQItem>;
    title?: string;
}

export const FAQ: React.FC<FAQProps> = ({ title = "Vanlige spørsmål", items }: FAQProps) => {
    const source: FAQItem[] = Array.isArray(items) ? items : Object.values(items ?? FAQ_DATA);

    if (_isEmpty(source)) {
        return null;
    }
    return (
        <Flex id="faq" direction="column" width="100%" align="center" justify="start">
            <Accordion type="multiple">
                <Accordion.Title as="h2" variant="title-300">
                    {title}
                </Accordion.Title>
                {source.map((item, index) => (
                    <Accordion.Item key={item.QUESTION ?? index} value={`open-${index}`}>
                        <Accordion.Header>
                            <Accordion.Trigger>{item.QUESTION}</Accordion.Trigger>
                        </Accordion.Header>
                        <Accordion.Content>
                            <p dangerouslySetInnerHTML={{ __html: item.ANSWER }} />
                        </Accordion.Content>
                    </Accordion.Item>
                ))}
            </Accordion>
        </Flex>
    );
};

export default FAQ;
